import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser"

const HalfTextItem = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { textItems } = props

    if (isMobile)
        return (
            <section className="flex col w100 white-bkg">

                {
                    textItems?.map((textItem,index) => {
                        return (
                            <section className="flex col acenter jcenter pad-30 gap-20" key={index}>
                                <h2 className="middle-section-title">{textItem[0]}</h2>

                                {textItem[1]?.map((paragraph, index) => {
                                    return (
                                        <article key={index}>{parse(paragraph)}</article>
                                    )
                                })}

                            </section >
                        )
                    })
                }

            </section >
        )
    else
        return (
            <section className="flex  jcenter pad-30 white-bkg main-middle-section-2 half-text-section gap-20">

                {
                    textItems?.map((textItem, index) => {
                        return (
                            <section className="flex col w50 gap-20" key={index}>
                                <h2 className="middle-section-title">{textItem[0]}</h2>

                                {textItem[1]?.map((paragraph, index) => {
                                    return (
                                        <article key={index}>{parse(paragraph)}</article>
                                    )
                                })}

                            </section>
                        )
                    })
                }

            </section >
        )

}

export default HalfTextItem